document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('#triptych-swiper-container.swiper-container', {
        loop: true,
        pagination: {
            el: '.triptych-swiper-pagination', // Updated with '-befAfter'
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
    });
});
